import { Theme, Font } from '@oneamerica/dxp-ui-components';
import ColorConstants from '../../../../constants/ColorConstants';

export default () =>
  Theme.Responsive.create({
    cardShadow: {
      borderRadius: 5,
      shadowRadius: 6,
      backgroundColor: Theme.Color.background,
      shadowColor: Theme.Color.backgroundShadow,
      shadowOffset: { width: 0, height: 3 },
      paddingHorizontal: Theme.Metrics.small,
      paddingVertical: Theme.Metrics.small,
    },
    cardHeader: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    cardHeaderTitle: {
      color: ColorConstants.iron,
      lineHeight: 36,
      fontFamily: Font.medium.fontFamily,
    },
    flex: { flex: 1 },
    horizontalDivider: {
      backgroundColor: ColorConstants.grey200,
      height: 1,
      width: '100%',
    },
    placeholder: {
      color: ColorConstants.grey200,
      fontStyle: 'italic',
      marginTop: 8,
      textAlign: 'center',
    },
    tableHeadingCell: {
      borderRightWidth: 1,
      borderRightColor: '#EAEAEA',
      paddingHorizontal: 16,
      textAlign: 'left',
      fontSize: 14,
      fontFamily: Font.medium.fontFamily,
      paddingVertical: 10,
      color: ColorConstants.iron,
      backgroundColor: '#F3F9FE',
    },
    tableHeadingCell1: {
      borderRightWidth: 1,
      borderRightColor: '#EAEAEA',
      paddingHorizontal: 16,
      textAlign: 'left',
      fontSize: 14,
      fontFamily: Font.medium.fontFamily,
      paddingVertical: 10,
      color: ColorConstants.iron,
      backgroundColor: '#F3F9FE',
    },
    tableCell1: {
      borderRightWidth: 1,
      borderRightColor: '#EAEAEA',
      paddingHorizontal: 16,
      textAlign: 'left',
      fontSize: 14,
      fontFamily: Font.regular.fontFamily,
      paddingVertical: 10,
      color: '#000000',
    },
    tableCell2: {
      borderRightWidth: 1,
      borderRightColor: '#EAEAEA',
      paddingHorizontal: 16,
      textAlign: 'left',
      fontSize: 14,
      fontFamily: Font.regular.fontFamily,
      paddingVertical: 10,
      color: '#000000',
    },
    tableHeadingCellText: {
      fontSize: 14,
      fontFamily: Font.medium.fontFamily,
      color: '#333333',
    },
    tableCellText: {
      fontSize: 14,
      fontFamily: Font.regular.fontFamily,
      color: '#000000',
    },
    tableCellText1: {
      fontSize: 14,
      fontFamily: Font.regular.fontFamily,
      color: '#000000',
    },
    font14: {
      fontSize: 14,
    },
    flexRow: { flexDirection: 'row' },
    selectedPageText: {
      fontWeight: 'bold',
      color: Theme.Color.oaBlueDark,
    },
    fontBold: {
      fontWeight: 'bold',
    },
  })();
